import DialPad from './DialPad.vue';

export default DialPad;
